import { Snackbar } from "@material-ui/core"
import { Alert } from "@material-ui/lab"
import React, { useContext, useEffect, useRef, useState } from "react"
import { Helmet } from "react-helmet"
import { ThemeProvider } from "styled-components"
import GameContext from "../../Context/GameContext"
import { RoomContext } from "../../Context/RoomContext"
import { InfoButton } from "../../co-op-game/host/info-button/InfoButton"
import ClosedRoom from "../../co-op-game/host/room/ClosedRoom"
import { Loading } from "../../co-op-game/host/room/Loading"
import { NotFound } from "../../co-op-game/host/room/NotFound"
import { OccupiedRoom } from "../../co-op-game/host/room/OccupiedRoom"
import { OpenInNewTab } from "../../co-op-game/host/room/OpenInNewTab"
import RoomWizard from "../../co-op-game/host/room/RoomWizard"
import { useCheckIfInIFrame } from "../../co-op-game/host/room/useCheckIfInIFrame"
import { Main } from "../../co-op-game/host/styles"
import FontStyles from "../../co-op-game/shared/fonts/FontStyles"
import { useGameData } from "../../co-op-game/shared/strapi/useGameData"
import { useGameProps } from "../../co-op-game/shared/useGameProps"
import { createHostSocket } from "../../services/socketServer"
import { useAnalytics } from "../../utils/useAnalytics"

const Host = ({ pageContext: { edubox } }) => {
  const { state, data } = useContext(RoomContext)
  const [name, setName] = useState(null)
  const [errorAlert, setErrorAlert] = useState(null)
  const ws = useRef(null)
  const [id, setId] = useState(null)
  const [roomState, setRoomState] = state
  // eslint-disable-next-line no-unused-vars
  const [roomData, setRoomData] = data

  const gameProps = useGameProps()
  const gameId = gameProps.gameId
  const { gameData, gameDataPending, theme } = useGameData(gameId)
  const [gameState, setGameState] = useState(null)

  useEffect(() => {
    if (name && gameId) {
      ws.current = createHostSocket({
        room: name,
        name: name,
        game: "COOP",
        type: gameId,
      })
      ws.current.on("connect_error", e => {
        setErrorAlert("Kan geen verbinding maken met de server")
      })
      ws.current.on("room_error", e => {
        console.error("room_error: ", e)
        // setErrorAlert(e);
      })
      ws.current.on("connect", () => {
        setId(name)
        document.title = "Co-op game: " + gameId || ""
      })
      ws.current.on("room_state", state => {
        //OPEN, CROWDED, FULL, OCCUPIED
        // console.log("room_state", state)
        setRoomState(state)
      })
      ws.current.on("room_event", room => {
        // { guests: [] }
        // console.log("room_event", room)
        setRoomData(room)
      })
      ws.current.on("room_action_event", gameState => {
        // console.log("room_action_event, gameState: ", gameState)
        setGameState(gameState)
      })
      return () => ws.current.close()
    }
  }, [name, setRoomState, setRoomData, gameId])

  const handleStart = () => {
    ws.current.emit("room_start")
  }
  const roomWizard = (
    <RoomWizard
      id={id}
      onNameEnter={name => setName(name)}
      onStart={handleStart}
      gameProps={gameProps}
      gameData={gameData}
    />
  )

  const onAction = action => {
    ws.current.emit("action", action)
  }

  const gameContextValue = {
    gameState,
    setGameState,
    gameProps,
    gameData,
    onAction,
  }

  const inIFrame = useCheckIfInIFrame()
  const switchState = () => {
    if (inIFrame) return <OpenInNewTab gameProps={gameProps} />
    if (roomState === null) return roomWizard
    switch (roomState) {
      case "CLOSED":
        return <ClosedRoom />
      case "OCCUPIED":
        return (
          <GameContext.Provider value={gameContextValue}>
            <InfoButton gameData={gameData} gameProps={gameProps} />
            <OccupiedRoom onAction={onAction} roomId={id} />
          </GameContext.Provider>
        )

      default:
        return roomWizard
    }
  }
  const handleErrorAlertClose = () => {
    setErrorAlert(null)
  }

  useAnalytics()

  if (gameDataPending) return <Loading />
  if (!gameData) return <NotFound />
  return (
    <>
      <Snackbar
        open={errorAlert !== null}
        autoHideDuration={6000}
        onClose={handleErrorAlertClose}
      >
        <Alert id="host_alert" onClose={handleErrorAlertClose} severity="error">
          {errorAlert}
        </Alert>
      </Snackbar>
      <ThemeProvider theme={theme}>
        <FontStyles />
        <Main>{switchState()}</Main>
      </ThemeProvider>
      <Helmet>
        <script
          src="//t.vrt.be/latest/vrtebahelper.min.js"
          async
          defer
        ></script>
        <script src="//t.vrt.be/latest/vrteba.min.js" async defer></script>
        <script
          src="//assets.adobedtm.com/e1f6ce4fc1d1/33a944fde33a/launch-EN7e1ba6190f45421f81025c684b630cc1.min.js"
          async
          defer
        ></script>
      </Helmet>
    </>
  )
}
export default Host
